import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, includeDeleted) {
  return apiFetch({
    endPoint: `OperationTypeDMS/GetDMSOperationTypes?organizedUnitId=${organizedUnitId}&includeDeleted=${includeDeleted}`,
    method: 'GET',
    body: null,
    token: token
  })
}
